import changeText from '../modules/changeText';
import changeTable from '../modules/changeTable';
import addProductModal from '../modules/addProductModal';

const account = () => {
  changeText.initialize();
  changeTable.initialize();
  addProductModal.initialize();
};

export default account;
